/* eslint-disable no-nested-ternary */
import React, { useMemo, useState } from 'react';

import { Col, Row } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { PACK_TYPE_NUMBER } from 'app/utils/constants';
import { setUser } from 'app/modules/Auth/_redux/AuthActions';
import { URLS } from 'app/config/urls';
import Button from 'app/components/Button';
import FormCard from 'app/components/FormCard';
import FormSpinner from 'app/components/FormSpinner';
import MyAccountLayout from 'app/modules/MyAccount/components/MyAccountLayout';

import Divider from 'app/components/Divider';
import { Colors } from 'app/utils/colors';
import Icon from 'app/components/Icon';
import { formatDateToLocale } from 'app/utils/dates';

import WholesalerPackTag from './components/WholesalerPackTag/WholesalerPackTag';
import FooterButtons from './components/FooterButtons';

import styles from './styles.module.scss';
import ExtraInfo from './components/ExtraInfo';
import { submitForm } from './utils/submitForm';

export default function WholesalerPack() {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const {
    packName,
    packId,
    walletPackPayment,
    subscriptionRenewCancelDate,
    packExpirationDate
  } = useMemo(() => user?.attributes, [user?.attributes]);
  const showForm =
    !subscriptionRenewCancelDate &&
    packId !== PACK_TYPE_NUMBER.B2B &&
    packId !== PACK_TYPE_NUMBER.WITHOUT;

  if (isLoading) {
    <MyAccountLayout currentPagePath={URLS.myAccountWholesalerPack}>
      <Col md={8}>
        <FormSpinner title="controlpanel.my_account.pack.title" showButtons />
      </Col>
    </MyAccountLayout>;
  }
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      isActivatePaymentByWallet: walletPackPayment
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      const response = await submitForm(user.id, values, intl, setIsLoading);

      if (response) {
        dispatch(setUser(response?.data));
        formik.resetForm({
          values: {
            isActivatePaymentByWallet: values.isActivatePaymentByWallet
          }
        });
      }
    }
  });

  return (
    <MyAccountLayout currentPagePath={URLS.myAccountWholesalerPack}>
      <Col md={8}>
        <FormCard
          title={intl.formatMessage({
            id: 'controlpanel.my_account.pack.title'
          })}
          buttons={
            showForm && (
              <>
                <Button
                  size="big"
                  text={intl.formatMessage({
                    id: 'controlpanel.global.cancel'
                  })}
                  onClick={formik.resetForm}
                  disabled={!(formik.isValid && formik.dirty)}
                />
                <Button
                  size="big"
                  type="secondary"
                  text={intl.formatMessage({
                    id: 'controlpanel.global.save'
                  })}
                  typeButton="submit"
                  onClick={formik.submitForm}
                  disabled={!(formik.isValid && formik.dirty)}
                />
              </>
            )
          }
        >
          <div className={styles.bbWholesalerContainer}>
            {subscriptionRenewCancelDate && (
              <Row>
                <Col md={12}>
                  <div className={styles.alert}>
                    <Icon
                      icon="circle-exclamation"
                      size="lg"
                      color={Colors.bbPrimaryDark}
                    />
                    <p>
                      {intl
                        .formatMessage({
                          id: 'controlpanel.wholesaler_pack.button.alert'
                        })
                        .replace(
                          '{date}',
                          formatDateToLocale(packExpirationDate)
                        )}
                    </p>
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={6} md={3} className={styles.packActive}>
                <Icon icon="cube" size="lg" color={Colors.bbGrey2} />
                <p>
                  {intl.formatMessage({
                    id: 'controlpanel.my_account.pack.form.pack_active'
                  })}
                </p>
              </Col>
              <Col xs={6} md={9}>
                <WholesalerPackTag
                  id={packId}
                  name={
                    packName ??
                    intl.formatMessage({
                      id: 'controlpanel.my_account.pack.without.tag'
                    })
                  }
                />
              </Col>
            </Row>
            <ExtraInfo
              formik={formik}
              showForm={showForm}
              isLoading={isLoading}
            />
            <Row>
              <Col>
                <Divider type="dash" />
              </Col>
            </Row>
            <FooterButtons />
          </div>
        </FormCard>
      </Col>
    </MyAccountLayout>
  );
}
